/*
|--------------------------------------------------------------------------
| Utilities: Slider
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.utilities.slider = {

	 /**
	 * Load all on a page
	 */
	"loadAllSliders": function(){
		var sliderObject = __gh__webApp.utilities.slider;

		$("[data-gh-slider-loaded=false]").each(function(){
			//alert("loadAllSliders:"+$container.length);
			var $slider	  			= $(this),
				sliderID			= '#'+$slider.attr("id");

			//Only load each slider once.
			if(!$slider.data("gh-slider-loaded")){
				$slider.attr("data-gh-slider-loaded",true);

				$slider.slick();

				sliderObject.bindEvents($slider);
			}
	  	});
	},

	"addSwipeTo": function(element){
		var $slider = $(element);

		$slider.find('.adDomOutter').on("swipe",function(){
		  alert('ok swiped now');
		});

	},

	"bindEvents": function($slider){
		var sliderID 					= "#" + $slider.attr("id"),
			slickPageCount				= 0,
			slickAdIntervalPageCount	= 0,
			slickAdInterval				= 3,
			delay						= 2000,
			adInjected					= false,
			track						= true,
			sliderInfo					= $(sliderID).parent().data('gh-slider-gallery-object');
			fetchHandlebarsView 		= __gh__webApp.utilities.fetch.handlebarsView.get,
			featAdHTML 					= fetchHandlebarsView({"view":"3rdParty/galleries/injectAd"}),
			disableThumbnailNavHTML 	= fetchHandlebarsView({"view":"3rdParty/galleries/disableNav"}),
			isMobile					= __gh__webApp.device.isMobile();

		//Expand caption menu
		if($slider.data("gh-slider-expander")){
			$(document).on("click",sliderID + " .gh-slider-caption .expander", function() {
			 //  if($(this).parent().hasClass('expanded')){
				// $(this).find('.expander-toggle').text('Show caption');
			 //  } else {
				// $(this).find('.expander-toggle').text('Hide caption');
			 //  }
			 //  $(this).parent().toggleClass('expanded');
			 //  $slider.slick('animateHeight');
			 //  
				if($(this).next('.description').is(':visible')) {
					$(this).find('.expander-toggle').text('Show caption');
					$(this).nextAll('.description,.credit').hide();
				}
				else {
					$(this).find('.expander-toggle').text('Hide caption');
					$(this).nextAll('.description,.credit').show();
				}

				$slider.slick('animateHeight');
			});
		}


		// Realign arrows
		$slider.on('setPosition', function(slick) {
			$slider.find('.slick-arrow').css('top', ($slider.find('.image').height()/2));
		});


		// After Slide Change
		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			var slickID 				= slick.$slider.context.id;
			
			slickPageCount++;
			
			//ad injection logic should only apply to gallery sliders and ad injection should should only fire once, set to fire on main DOM
			if(!sliderInfo || sliderInfo.main !== slickID) { return; }
			
			var mainSlider = $('#'+sliderInfo.main);
			
			//Tracking
			if (track){
				var galleryTitle 			= sliderInfo.title,
					isAdParam				= (slickPageCount==3 || (((slickPageCount)-3)%5) == 0),
					adParam					= (isAdParam) ? "/ad" : "",
					imageTrackingURL		= location.protocol + '//' + location.host + '/photogallery/'+galleryTitle+'/'+currentSlide + adParam,
					galleryTrackingURL		= ("link" in sliderInfo) ? sliderInfo.link : null;
	
				if(galleryTitle){
					__gh__webApp.utilities.tracker.trackGallery({
						"galleryURL": galleryTrackingURL,
						"imageURL": imageTrackingURL
					});
				}
				
			} else {
				track = true;
			}

			
			//No ad injection on mobile
			if (isMobile){ return; }

			if(adInjected) { //if ad has already been injected and a user has clicked something, remove ad, flag it's gone, reset counter, and exit immediately
				adInjected 		= false;
				slickAdIntervalPageCount 	= 1;
				mainSlider.find('.adDomOutter').remove();

				return;
			}

			//increase click counter by 1
			slickAdIntervalPageCount++;

			//if three clicks
			if(slickAdInterval !== slickAdIntervalPageCount){ return; }

			//increase interval to 5 clicks
			slickAdInterval = 5;

			//disable arrows
			$slider.slick('slickSetOption', 'arrows', false, true);

			//disable thumbnail nav
			$('#'+sliderInfo.nav).addClass('position-relative').prepend(disableThumbnailNavHTML);

			//inject ad into bucket
			$('#'+sliderInfo.main).addClass('position-relative').prepend(featAdHTML);

			//fire ad code
			__gh__webApp.ads.dfp.createLazySlot();

			//delay for 2 seconds, then allow user to leave again
			setTimeout(function(){

				//enable arrows
				$slider.slick('slickSetOption', 'arrows', true, true);

				//bind swipe event to ad dom to handle removal
				__gh__webApp.utilities.slider.addSwipeTo(sliderInfo.main);

				//enable thumbnail nav
				$('#'+sliderInfo.nav).find('.thumbnail-gallery-disable').remove();
				
				track = false;
				
				//go to previous slide so user isn't moving past an image they haven't seen
				$slider.slick('slickGoTo', (currentSlide), true);
				
				//flag that we've handled ad injection
				adInjected = true;
				
				slickPageCount--;

			}, delay);

		});
	}
};